module.exports = __webpack_public_path__ + "8dc2281629e40729a63e1919871027f2.png";